export class Syncro {
  idSyncro: number = 0;
  date?: Date;
  statut?: string;
}
